module.exports = __webpack_public_path__ + "static/media/10.bb736cf5.jpg";